import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import BalancePage from "components/Balance/BalancePage"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import FailBalance from "components/PurchasePage/Preview/Payment/FailedPage"
import Loader from "components/Reusable/Loader"
import { GetStaticProps } from "next"
import { useState } from "react"

type BalanceStaticProps = {
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<BalanceStaticProps> = async () => {
  const seo = {
    title: " בדיקת יתרה גיפט קארד מקדונלד'ס | McDonald's giftcard",
    description:
      "בירור ובדיקת יתרת כרטיס וגיפט קארד במקדונלד'ס. כאן תוכלו לבדוק את יתרת הכרטיס במהירות",
    keywords: " בדיקת יתרה גיפט קארד מקדונלד'ס | McDonald's giftcard",
  }
  return {
    props: { seo },
    revalidate: 60,
  }
}

export enum BalanceSteps {
  Balance = 1,
  FAIL = 2,
  LOADER = 3,
}

const Balance = ({ seo }: BalanceStaticProps) => {
  const [balanceSteps, setBalanceteps] = useState(BalanceSteps.Balance)
  const [refList, setRefList] = useState([])

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      {balanceSteps === BalanceSteps.Balance && (
        <BalancePage setRefList={setRefList} setBalanceteps={setBalanceteps} />
      )}
      {balanceSteps === BalanceSteps.FAIL && (
        <FailBalance
          setRefList={setRefList}
          title="אופסי, משהו השתבש בדרך"
          text="העמוד שחיפשת לא קיים או שיש כרגע בעיה זמנית להגיע אליו"
          link="/balance"
        />
      )}
      {balanceSteps === BalanceSteps.LOADER && <Loader />}
    </>
  )
}

export default Balance
